import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { useDeleteTag } from 'features/tags';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogVariantOptions } from 'shared/assets/styles';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { Tag } from 'shared/types/tag';

import * as Styled from './dialog.style';

export type DeleteTagDialogProps = {
  tag: Tag;
  onClose: () => void;
};

export const DeleteTagDialog: React.FC<DeleteTagDialogProps> = ({
  tag,
  onClose,
}) => {
  const { t } = useTranslation();
  const { submit: deleteTag } = useDeleteTag();

  const onDelete = () => {
    deleteTag(tag);
    onClose();
  };

  return (
    <Dialog open onClose={onClose} variant={DialogVariantOptions.ExtraSmall}>
      <Styled.DialogHeader>
        <Typography variant="h5" component="h1">
          {t('context-menus.tags.forms.delete.title')}
        </Typography>
      </Styled.DialogHeader>

      <Styled.DialogBody>
        <Typography variant="body2">
          {t('context-menus.tags.forms.delete.body', { name: tag.name })}
        </Typography>
      </Styled.DialogBody>

      <Styled.DialogFooter>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.White}
          onClick={onClose}
        >
          {t('context-menus.tags.forms.delete.footer.cancel')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onDelete}>
          {t('context-menus.tags.forms.delete.footer.submit')}
        </Button>
      </Styled.DialogFooter>
    </Dialog>
  );
};
